import {Component, input} from '@angular/core';

@Component({
  selector: 'app-prudent-expandable-button',
  imports: [],
  templateUrl: './prudent-expandable-button.component.html',
  styleUrl: './prudent-expandable-button.component.scss',
})
export class PrudentExpandableButtonComponent {
  readonly title = input.required<string>();
  readonly image = input.required<string>();
  isExpanded = false;

  toggleExpand() {
    this.isExpanded = !this.isExpanded;
  }
}
